
import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import { isEmpty, split } from 'lodash';

const OrcaSecurityMappingForm = forwardRef(function OrcaSecurityMappingForm({disableProjectFields = false, ...props}, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { accountId, accountName } = props.record;
      return [{id: accountId, name: accountName }]
    }
    return [];
  });

  const [initialValues] = useState(() => {
      if (props.record) {
        return [
          {
            product: props.defaultProduct,
            subProduct: props.defaultSubProduct,
            subProductId: props.defaultSubProductId,
            environment: props.defaultEnvironment,
            ingestionType: props.record.ingestionType === "All" || isEmpty(props.record.ingestionType) ? undefined : split(props.record.ingestionType, ","),
          },
        ];
      }
      return [
        {
          product: props.defaultProduct,
          subProduct: props.defaultSubProduct,
          subProductId: props.defaultSubProductId,
          environment: props.defaultEnvironment,
          ingestionType: ["Alerts"],
        },
      ];
    });

  useEffect(() => {
      const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
      promise.then((response) => {
        const { projects } = response;
        setProjects(projects);
      }).catch((err)=>{
        message.error('Problem fetching projects')
      });
      
      return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    const { accountId, ingestionType} = config;
    return {
      accountId,
      accountName: projects.find(project => project.id === accountId)?.name,
      ingestionType: isEmpty(ingestionType) || ingestionType.length === 2 ? "All" : ingestionType.join(),
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id }),
    };
  }

  const extraFields = useMemo(() => ([{
      name: 'accountId',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Account Name',
      options: projects.map(option => {
        const { label = option.name, value = option.id } = option;
        return { label, value }
      }),
      required: true,
      disabled: disableProjectFields,
      props: {
        autoFocus: !disableProjectFields
      }
    },
    {
      name: 'ingestionType',
      colSpan: '12',
      type: FieldTypes.MULTI_SELECT,
      label: 'Select Ingestion Type',
      placeholder: "Leave blank to select all",
      options: ["Vulnerabilities", "Alerts"]
    },
  ]), [projects, disableProjectFields]);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return {
      accountId: config.accountId,
      ingestionType: config.ingestionType === "All" || isEmpty(config.ingestionType) ? undefined : split(config.ingestionType, ","),
      //send the property received in config
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id }) 
    };
  }, []);

  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={extraFields}
      formDefaultValues={initialValues}
      {...props}
    />
  )
})

export default OrcaSecurityMappingForm;
